import { Descriptions, Tag, Card, Button } from "antd";
import { DownloadOutlined, FileTextOutlined } from "@ant-design/icons";
import trans from "../../../../utils";
import { formatDateString } from "../../../../JsHelpers/DateFormat";

export function GeneralTab({ data }) {
  const statusColors = {
    ACTIVE: `green`,
    INACTIVE: `red`,
  };

  const getFileIconUrl = (type = "") => {
    const lowerType = type.toLowerCase();
    if (lowerType === "image/png") {
      return `${process.env.PUBLIC_URL}/assets/PNG.svg`;
    } else if (lowerType === "image/jpg" || lowerType === "image/jpeg") {
      return `${process.env.PUBLIC_URL}/assets/JPG.svg`;
    } else if (lowerType === "application/pdf") {
      return `${process.env.PUBLIC_URL}/assets/PDF.svg`;
    } else {
      return `${process.env.PUBLIC_URL}/assets/Excel.svg`;
    }
  };

  const downloadAllAttachments = async () => {
    if (!data?.attachments || data.attachments.length === 0) return;

    for (let i = 0; i < data.attachments.length; i++) {
      const file = data.attachments[i];
      setTimeout(() => {
        const link = document.createElement("a");
        link.href = file?.url;
        link.download =
          file?.originalName ||
          file?.name ||
          file?.filename ||
          `attachment-${i + 1}`;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, i * 200);
    }
  };

  if (!data) {
    return null;
  }

  const items = [
    {
      label: trans("Team Code"),
      children: data?.code || "-",
      span: 3,
    },
    {
      label: trans("Team Name"),
      children: data?.name || "-",
      span: 3,
    },
    {
      label: trans("Company"),
      children: data?.companyProject?.company?.name || "-",
      span: 3,
    },
    {
      label: trans("Project"),
      children: data?.companyProject?.project?.name || "-",
      span: 3,
    },
    {
      label: trans("Status"),
      span: 6,
      children: (
        <Tag
          color={statusColors[data.status] || statusColors.INACTIVE}
          className="text-capitalize"
        >
          {trans(data.status)}
        </Tag>
      ),
    },
    {
      label: trans("Trades"),
      span: 6,
      children:
        data?.trades && data.trades.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {data.trades.map((trade, index) => (
              <Tag key={index} color="blue">
                {trade?.name}
              </Tag>
            ))}
          </div>
        ) : (
          "-"
        ),
    },
    {
      label: trans("Assigned Zones"),
      span: 6,
      children:
        data?.assignedZones && data.assignedZones.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {data.assignedZones.map((zone, index) => (
              <Tag key={index} color="purple">
                {zone?.name ? zone?.name : zone?.code}{" "}
                {zone?.code && zone?.name ? `- ${zone?.code}` : ""}
              </Tag>
            ))}
          </div>
        ) : (
          "-"
        ),
    },
    {
      label: trans("Members Count"),
      children: data?.members?.length || data?._count?.members || 0,
      span: 3,
    },
    {
      label: trans("Assigned Snags"),
      children: data?._count?.assignedSnags || 0,
      span: 3,
    },
    {
      label: trans("Created At"),
      children: data?.createdAt ? formatDateString(data.createdAt) : "-",
      span: 3,
    },
    {
      label: trans("Updated At"),
      children: data?.updatedAt ? formatDateString(data.updatedAt) : "-",
      span: 3,
    },
  ];

  return (
    <div style={{ padding: "16px 0" }}>
      <Descriptions
        title={trans("Team Information")}
        bordered
        column={6}
        items={items}
        size="small"
      />
      <div className="mt-1rem">
        {data?.attachments && data?.attachments.length > 0 && (
          <div className="col-lg-12 mt-3">
            <Card className="mb-3">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2">
                  <FileTextOutlined style={{ color: "green" }} />
                  <h5 className="mb-0">{trans("Attachments")}</h5>
                </div>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={downloadAllAttachments}
                  size="middle"
                >
                  {trans("Download All")}
                </Button>
              </div>
              <div className="d-flex flex-column gap-3">
                {data.attachments.map((file, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between align-items-center border p-3 rounded pointer"
                    onClick={() => window.open(`${file?.url}`, "_blank")}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <img
                        src={getFileIconUrl(file?.mimetype)}
                        alt={file?.mimeType || file?.type || "file"}
                        width={28}
                      />
                      <div>
                        {file?.filename ||
                          `${trans("Attachments")} ${index + 1}`}
                        <br />
                        {file?.fileSize && (
                          <div className="text-muted small">
                            {file.fileSize} MB
                          </div>
                        )}
                        {file?.uploader && (
                          <div className="text-muted small">
                            {trans("Uploaded by")}{" "}
                            <span className="fw-800">
                              {file.uploader?.name}
                            </span>{" "}
                            {trans("on")}{" "}
                            <span className="fw-800">
                              {formatDateString(file.uploaded_at)}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    <DownloadOutlined
                      className="text-secondary pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        const link = document.createElement("a");
                        link.href = `${file?.url}`;
                        link.download =
                          file?.originalName ||
                          file?.name ||
                          file?.filename ||
                          `attachment-${index + 1}`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                    />
                  </div>
                ))}
              </div>
            </Card>
          </div>
        )}
      </div>
    </div>
  );
}
